import { captureAppError, getGlobalSentry } from "./sentry";

export interface RouteErrorInput {
  route: string;
  error: Error & { digest?: string };
}

export interface RouteErrorReport {
  route: string;
  message: string;
  digest?: string;
}

export function buildRouteErrorReport({ route, error }: RouteErrorInput): RouteErrorReport {
  return {
    route,
    message: error.message,
    digest: error.digest,
  };
}

export function captureRouteError(input: RouteErrorInput, sentry = getGlobalSentry()): RouteErrorReport {
  const report = buildRouteErrorReport(input);
  captureAppError(input.error, {
    route: report.route,
    extra: { digest: report.digest, message: report.message },
  }, sentry);
  return report;
}
